<template>
    <div class="sucOrdered headNav">
        <div class="sucImg"><img src="@/assets/images/template/mart_success.png"/><span>{{$t('success.infoTit_1')}}</span></div>
        <div class="sucList">
            <ul>
                <li><p>{{$t('success.positionID')}}</p><span>{{$route.query.ID}}</span></li>
                <li><p>{{$t('success.positionPro')}}</p><span>{{quote.symbolNotify[util.getShowPrdCode($route.query.Symbol).replace("_CF","")].szShortName}}</span></li>
                <li v-if="$route.query.StopLoss != 0"><p>{{$t('trade.products.stopLoss')}}</p><span>{{Number($route.query.StopLoss).toFixed(marketInfo.symbolData.digits)}}<span class="inline" v-if="$route.query.setStopLossTip">(${{$route.query.setStopLossTip}})</span></span></li>
                <li v-else><p>{{$t('trade.products.stopLoss')}}</p><span>{{$t('trade.products.notSet')}}</span></li>
                <li v-if="$route.query.TakeProfit != 0"><p>{{$t('trade.products.stopProfit')}}</p><span>{{Number($route.query.TakeProfit).toFixed(marketInfo.symbolData.digits)}}<span class="inline" v-if="$route.query.setStopProfitTip">(${{$route.query.setStopProfitTip}})</span></span></li>
                <li v-else><p>{{$t('trade.products.stopProfit')}}</p><span>{{$t('trade.products.notSet')}}</span></li>
                <li><p>{{$t('trade.products.validityPeriod')}}</p><span>{{$t('trade.products.validWeek')}}</span></li>
            </ul>
        </div>
        <div class="sucBtn only">
            <span @click="closeSuc(0)">{{$t('success.viewPositions')}}</span>
        </div>
    </div>
</template>

<script>
    require('@/assets/css/sucOrdered.css');
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    export default {
        data(){
            return {
                util:Util,
            }
        },
        computed:{
            ...mapState(['quote','symbolInfo']),
            marketInfo: {
                code:{
                    get(){
                        if (this.quote.symbolNotify[Util.getShowPrdCode(this.$route.query.Symbol).replace("_CF","")]) return this.quote.symbolNotify[Util.getShowPrdCode(this.$route.query.Symbol).replace("_CF","")].uiCodeID;
                        return "";
                    }
                },
                get() {
                    let symbolData = {};
                    if (this.quote.symbolNotify && this.quote.symbolNotify[Util.getShowPrdCode(this.$route.query.Symbol).replace("_CF","")]){
                        const code = this.quote.symbolNotify[Util.getShowPrdCode(this.$route.query.Symbol).replace("_CF","")].uiCodeID;
                        if (code && this.quote.notify[code]) {
                            const source = this.quote.notify[code].uiSourceCode;
                            if (this.symbolInfo.codeMap[source]) symbolData = this.symbolInfo.codeMap[source];
                        }
                    }
                    return {
                        symbolData: symbolData,
                    };
                }
            },
        },
        methods:{
            back() {
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/positionChart',query:{id:this.code,positionId:this.id}})
            },
            closeSuc(type){
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                this.$bus.$emit('loading', false);
                this.$router.replace({path: '/home/trade',query:{type:type}})
            },
        },
        mounted(){
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
        },
        activated(){
            this.$bus.$emit('loading', true);
        },
    }
</script>
